import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { LightBulbIcon } from '@heroicons/react/24/outline'

/**
 * VH-235: which of the user's memories a generated result was given — "Took into account: no
 * coconut powder; trains 6 of 7 days". A contradicted one is marked, because the result followed
 * the records instead. Renders nothing when no memory was given.
 */
export function MemoryUsedNote({ memories, className = '' }) {
  const { t } = useTranslation()
  if (!memories?.length) return null
  return (
    <p className={`flex items-start gap-1.5 text-xs text-gray-600 ${className}`} data-testid="memory-used-note">
      <LightBulbIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        {t('memory.used')}{' '}
        {memories.map((m, i) => (
          <span key={m.id}>
            {i > 0 && '; '}
            {m.text}{m.contradicted ? ` (${t('memory.usedContradicted')})` : ''}
          </span>
        ))}
        {' · '}<Link to="/profile?tab=memory" className="underline">{t('memory.manage')}</Link>
      </span>
    </p>
  )
}

export default MemoryUsedNote
